import apiClient from './axios/toolsClient';

export async function getToolsCostSheetApi() {
  return apiClient
    .get('/costsheets')
    .then((resp) => resp.data)
    .catch(() => false);
}
